<template>
    <div class='component'>
        <p class='description'><span class="c-gr">Welcome!</span></p>
        <h1 class="c-gy2">C&C Ventures LLC</h1>
        
        <p class='description'>
            Hello, we are <span class="c-gr">Chris and Connor</span>, cofounders of C&C Ventures LLC. Here we <span class="c-gr">strive for excellence</span> in software products. 
            During the day, we are both Software Engineers with over <span class="c-gr">12+ years of experience</span> building mobile apps, websites, APIs, and even some games.
            At night, we are <span class="c-gr">entrepreneurs</span> who are passionate about creating products that <span class="c-gr">solve real-world problems</span> and <span class="c-gr">improve people's lives</span>.
        </p>

        <button class="rounded-button" @click="$emit('scrollToSkills')">
            Together, we have built some pretty cool products <span class="arrow">&#x2192;</span>
        </button>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>
    .description {
        max-width: 700px;
        letter-spacing: 0.1rem;
        font-weight: lighter;
        color: var(--gray);
    }
</style>